export default "__VITE_ASSET__DSH2PtCD__"